export default "__VITE_ASSET__97aa994d__"